import type { Components } from '@mui/material/styles';

export default function MuiTableFooter(): Components['MuiTableFooter'] {
  return {};
}
